/**
 * Created by olga on 01.08.2023
 */

const UserIdsHistory = function () {
    this.ids = [];
    this.diff = [];

    this.load();
    this.sendToServer();
};

UserIdsHistory.prototype.load = function () {
    const save = cleverapps.dataLoader.load(DataLoader.TYPES.USER_IDS_HISTORY);

    if (save) {
        this.ids = save.ids || [];
        this.diff = save.diff || [];
    }
};

UserIdsHistory.prototype.add = function (id) {
    if (PlatformLogic.isTmpId(id) && cleverapps.user.getLevel() === 0 && cleverapps.user.getExp() === 0 && !cleverapps.paymentsHistory.isPayer()) {
        return;
    }

    if (id !== connector.platform.getUserID() && !this.ids.includes(id)) {
        console.log("UserIdsHistory add", id);
        this.ids.push(id);
        this.diff.push(id);
        this.save();
        this.sendToServer();
    }
};

UserIdsHistory.prototype.sendToServer = function () {
    if (this.diff.length) {
        cleverapps.RestClient.post(`/useridshistory/${encodeURIComponent(connector.platform.getUserID())}`, {
            ids: this.diff
        }, () => {
            console.log("UserIdsHistory send success");
            this.diff = [];
            this.save();
        }, () => {
            console.log("UserIdsHistory send failed");
        });
    }
};

UserIdsHistory.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.USER_IDS_HISTORY, {
        ids: this.ids,
        diff: this.diff
    });
};